import type { AdminClientContext, AdminHttpClient } from './client.js';

type MethodKeys =
  | 'loginWithPassword'
  | 'platformLoginWithPassword'
  | 'partnerLoginWithPassword'
  | 'sessionCapabilities'
  | 'refreshSession'
  | 'revokeSession'
  | 'refresh';

export function buildAuthMethods(ctx: AdminClientContext) {
  const { transport } = ctx;

  return {
    loginWithPassword: (email, password, tenantId, sessionProtocol) =>
      transport.loginWithPassword({
        ...(sessionProtocol ? { sessionProtocol } : {}),
        email,
        password,
        ...(tenantId?.trim() ? { tenantId: tenantId.trim() } : {}),
      }),
    platformLoginWithPassword: (email, password, sessionProtocol) =>
      transport.platformLoginWithPassword({ email, password, ...(sessionProtocol ? { sessionProtocol } : {}) }),
    partnerLoginWithPassword: (email, password, sessionProtocol) =>
      transport.partnerLoginWithPassword({ email, password, ...(sessionProtocol ? { sessionProtocol } : {}) }),
    sessionCapabilities: () => { ctx.assertAuthTransport(); return transport.sessionCapabilities(); },
    refreshSession: (token) => { ctx.assertAuthTransport(); return transport.refreshSession(token); },
    revokeSession: (input) => { ctx.assertAuthTransport(); return transport.revokeSession(input); },
    refresh: (refreshToken) => transport.refresh(refreshToken),
  } satisfies Pick<AdminHttpClient, MethodKeys>;
}
